var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { FilespaceUpgradingDashboard, } from '@lucidlink/workspacemanagement';
import { FilespaceWebDashboard } from './FilespaceWebDashboard';
export const FilespaceDashboard = ({ filespace }) => {
    switch (true) {
        case filespace.isMigrating:
            return _jsx(FilespaceUpgradingDashboard, { filespace: filespace });
        default:
            return _jsx(FilespaceWebDashboard, { filespace: filespace });
    }
};
_react_refresh_temp_1 = FilespaceDashboard;
$RefreshReg$(_react_refresh_temp_1, "FilespaceDashboard");
